import sanitize from 'sanitize-filename';

/** Characters that are invalid in a filename across Windows/macOS/Linux, plus control characters. */
// eslint-disable-next-line no-control-regex
const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\x00-\x1f]/;

/**
 * Builds a default base filename (without extension) as "<prefix> - <client>", with the client
 * name sanitised. Falls back to just "<prefix>" when no client name is available.
 */
export function buildDefaultFileName(prefix: string, clientName: string | undefined): string {
    const safeName = clientName ? sanitize(clientName, { replacement: '' }).trim() : '';
    return safeName ? `${prefix} - ${safeName}` : prefix;
}

/**
 * Validates a user-entered base filename. Returns an error message when invalid, or null when the
 * name is acceptable. Only the base name is validated here — the extension is appended at download.
 */
export function validateFileName(name: string): string | null {
    if (name.trim().length === 0) return 'Filename is required.';
    if (INVALID_FILENAME_CHARS.test(name)) return 'Filename cannot contain: \\ / : * ? " < > |';
    return null;
}
